/**
 * An enumeration of all the possible workflow states.
 * Should mirror the backend static class.
 */
export enum WorkflowStates {
  NEED_IDENTIFIED = 'NEED_IDENTIFIED',
  SUBMISSION_IN_PREPARATION = 'SUBMISSION_IN_PREPARATION',
  PM_APPRAISAL = 'PM_APPRAISAL',
  PM_APPRAISAL_REWORK = 'PM_APPRAISAL_REWORK',
  DAS_ADMIN = 'DAS_ADMIN',
  DAS_ADMIN_REWORK = 'DAS_ADMIN_REWORK',
  SPECIALIST_SUBMISSION_POINT = 'SPECIALIST_SUBMISSION_POINT',
  SPECIALIST_SUBMISSION_POINT_REWORK = 'SPECIALIST_SUBMISSION_POINT_REWORK',
  SPECIALIST_REVIEW = 'SPECIALIST_REVIEW',
  REWORK_REQUIRED = 'REWORK_REQUIRED',
  PM_DETERMINATION = 'PM_DETERMINATION',
  APPROVED = 'APPROVED',
  APPROVED_WITH_CONDITIONS = 'APPROVED_WITH_CONDITIONS',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
}

export const DETERMINED_STATES: ReadonlyArray<WorkflowStates> = [
  WorkflowStates.APPROVED,
  WorkflowStates.APPROVED_WITH_CONDITIONS,
  WorkflowStates.REJECTED,
];

export const DAS_2_APPROVED_STATES: ReadonlyArray<string> = [
  'Approved with comments',
  'Approved',
  'No Objection',
  'Application Received',
  'Approved - (Delegated SATA G7)',
  'Relaxation within Standard',
  'AIP with Conditions',
  'Approved in Principle',
  'Approved With Conditions',
  'Approved with Comments',
  'Agreed as Existing Departure',
  'No Objection with Conditions',
  'No Comment',
  'Request received',
  'Conditionally Approved',
  'PM advised to approve',
  'Historic',
  'Agreed as per Existing Design',
  'Approved With Comments',
  'No Comment Given',
  'Approved by TSE',
  'Recommend Acceptance',
  'Replied to Applicant',
  'approved',
  'No Objection in Principle',
];
